module.exports = __webpack_public_path__ + "static/media/Search.db69dbdb.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/Search.svg
// module id = 567
// module chunks = 0